/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RowSelectionReadOnlyInfo
 */
export interface RowSelectionReadOnlyInfo {
    /**
     * 
     * @type {Array<string>}
     * @memberof RowSelectionReadOnlyInfo
     */
    allSelectedRowIds: Array<string>;
}

/**
 * Check if a given object implements the RowSelectionReadOnlyInfo interface.
 */
export function instanceOfRowSelectionReadOnlyInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "allSelectedRowIds" in value;

    return isInstance;
}

export function RowSelectionReadOnlyInfoFromJSON(json: any): RowSelectionReadOnlyInfo {
    return RowSelectionReadOnlyInfoFromJSONTyped(json, false);
}

export function RowSelectionReadOnlyInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RowSelectionReadOnlyInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allSelectedRowIds': json['allSelectedRowIds'],
    };
}

export function RowSelectionReadOnlyInfoToJSON(value?: RowSelectionReadOnlyInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allSelectedRowIds': value.allSelectedRowIds,
    };
}

